class ProductPriceModel {
    // Product Price Information (Main Details)
    productPrices?: {
        rateMainId?: number;
        categoryId?: number;
        name?: string;
        effectiveDate?: string;
        tenantId?: number; // You may need to set the tenantId value accordingly.
    }[];

    // Rate Subscription Details (Detailed Rate Information)
    rateSubs?: {
        rateSubId?: number;
        categoryId?: number;
        effectiveDate?: string;
        productId?: number;
        code?: string;
        productName?: string;
        basic?: number;
        cgst?: number;
        sgst?: number;
        igst?: number;
        rate?: number;
        cardrate?: number;
        freerate?: number;
    }[];

    // Optional properties for compatibility with existing use cases
    id?: number;
    count?: number;
    rateMainId: number;
    categoryId?: number;
    name?: string;
    effectiveDate?: string;
    rateSubId?: number;
    productId?: number;
    code?: string;
    productName?: string;
    basic?: number;
    cgst?: number;
    sgst?: number;
    igst?:number;
    rate?: number;
    cardrate?: number;
    freerate?: number;
    inEdit?: boolean;
}

export default ProductPriceModel;
